"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterComponentsProvider = exports.useAttributeFilterComponentsContext = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../utils");
var AttributeFilterComponentsContext = react_1.createContext({
    ErrorComponent: utils_1.ThrowMissingComponentError("ErrorComponent", "AttributeFilterComponentsContext"),
    LoadingComponent: utils_1.ThrowMissingComponentError("LoadingComponent", "AttributeFilterComponentsContext"),
    DropdownButtonComponent: utils_1.ThrowMissingComponentError("DropdownButtonComponent", "AttributeFilterComponentsContext"),
    DropdownBodyComponent: utils_1.ThrowMissingComponentError("DropdownBodyComponent", "AttributeFilterComponentsContext"),
    DropdownActionsComponent: utils_1.ThrowMissingComponentError("DropdownActionsComponent", "AttributeFilterComponentsContext"),
    ElementsSearchBarComponent: utils_1.ThrowMissingComponentError("ElementsSearchBarComponent", "AttributeFilterComponentsContext"),
    ElementsSelectComponent: utils_1.ThrowMissingComponentError("ElementsSelectComponent", "AttributeFilterComponentsContext"),
    ElementsSelectLoadingComponent: utils_1.ThrowMissingComponentError("ElementsSelectLoadingComponent", "AttributeFilterComponentsContext"),
    ElementsSelectItemComponent: utils_1.ThrowMissingComponentError("ElementsSelectItemComponent", "AttributeFilterComponentsContext"),
    ElementsSelectErrorComponent: utils_1.ThrowMissingComponentError("ElementsSelectErrorComponent", "AttributeFilterComponentsContext"),
    ElementsSelectActionsComponent: utils_1.ThrowMissingComponentError("ElementsSelectActionsComponent", "AttributeFilterComponentsContext"),
    EmptyResultComponent: utils_1.ThrowMissingComponentError("EmptyResultComponent", "AttributeFilterComponentsContext"),
    StatusBarComponent: utils_1.ThrowMissingComponentError("StatusBarComponent", "AttributeFilterComponentsContext"),
    FilterError: utils_1.ThrowMissingComponentError("FilterError", "AttributeFilterComponentsContext"),
    FilterLoading: utils_1.ThrowMissingComponentError("FilterLoading", "AttributeFilterComponentsContext"),
});
AttributeFilterComponentsContext.displayName = "AttributeFilterComponentsContext";
/**
 * @internal
 */
exports.useAttributeFilterComponentsContext = function () {
    return react_1.useContext(AttributeFilterComponentsContext);
};
/**
 * @internal
 */
exports.AttributeFilterComponentsProvider = function (props) {
    var children = props.children, components = tslib_1.__rest(props, ["children"]);
    return (react_1.default.createElement(AttributeFilterComponentsContext.Provider, { value: components }, children));
};
//# sourceMappingURL=AttributeFilterComponentsContext.js.map